import React from "react";
import ReplyMessage from '../Messages/ReplyMessage'

export const mediaBlockRenderer = block => {
	if (block.getType() === "atomic") {
		return {
			component: Media,
			editable: false
		};
	}

	return null;
};

const Image = props => {
	if (!!props.src) {
		return <img alt="blockimg" src={props.src} />;
	}
	return null;
};

const Media = props => {
	const entity = props.contentState.getEntity(props.block.getEntityAt(0));
	const { src } = entity.getData();
	const type = entity.getType();

	let media;

	if (type === "image") {
		media = <Image src={src} />;
	}
	else{
		alert('rpm')
	media =  <ReplyMessage {...this.props.message}></ReplyMessage>
	}
	return media;
};
